export const departmentList = (state, rootState) => {
	return state.departmentList;
}

export const objDepartmentEdit = (state, rootState) => {
	return state.objDepartmentEdit;
}

export const departmentRangesList = (state, rootState) => {
  return state.departmentRangesList;
}

export const productCodes = (state, rootState) => {
  return state.productCodes;
}

export const departmentUsers = (state, rootState) => {
  return state.departmentUsers;
}

export const departmentStatuses = (state, rootState) => {
  return state.departmentStatuses;
}

export const departmentLoader = (state, rootState) => {
  return state.departmentLoader;
}

export const departmentUsedRanges = (state, rootState) => {
  return state.departmentUsedRanges;
}

export const userBranchesDepartments = (state, rootState) => {
  return state.userBranchesDepartments;
}

export const lookupArray = (state, rootState) => {
  return state.lookupArray;
}
